import { PERIOD_DISPLAY, Period } from '@kwenta/sdk/constants'
import { FC } from 'react'
import styled from 'styled-components'

import UnderlineTabs from 'components/Button/UnderlineTabs'
import { selectSelectedPortfolioTimeframe } from 'state/futures/common/selectors'
import { setSelectedPortfolioTimeframe } from 'state/futures/reducer'
import { useAppDispatch, useAppSelector } from 'state/hooks'

const TIMEFRAMES: Period[] = [Period.ONE_WEEK, Period.ONE_MONTH, Period.ONE_YEAR]

export const Timeframe: FC = () => {
	const dispatch = useAppDispatch()
	const selectedTimeframe = useAppSelector(selectSelectedPortfolioTimeframe)

	return (
		<StyledUnderlineTabs
			options={Object.values(TIMEFRAMES).map((o) => ({
				name: o,
				label: PERIOD_DISPLAY[o],
				active: selectedTimeframe === o,
				onClick: () => dispatch(setSelectedPortfolioTimeframe(o as Period)),
			}))}
		/>
	)
}

const StyledUnderlineTabs = styled(UnderlineTabs)`
	.title-container > p {
		font-size: 12px;
	}
`
